import React from "react"
import ReactDOM from "react-dom/client"
import "./main.css"

import { router } from "./lib/router"
import { RouterProvider } from "@tanstack/react-router"
import { QueryClientProvider } from "@tanstack/react-query"
import { queryClient } from "./lib/react-query"
import { Settings } from "luxon"
import { client } from "./lib/ts-rest.ts"
import { initAnalytics, Sentry } from "./lib/log.ts"

Settings.throwOnInvalid = true
declare module "luxon" {
  interface TSSettings {
    throwOnInvalid: true
  }
}

initAnalytics()

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p>Something went wrong</p>}>
      <QueryClientProvider client={queryClient}>
        <client.ReactQueryProvider>
          <RouterProvider router={router} />
        </client.ReactQueryProvider>
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
)
